export default {"src":"/_next/static/media/readySite3.4adb9e83.svg","height":192,"width":220,"blurWidth":0,"blurHeight":0};